import actionTypes from './actionTypes';
import { action, generateErrorAction } from '../actions';
import API from '../../apis';

export const fetchReservationInvoiceDetails = id => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.reservations
        .fetchReservationInvoiceDetails(id)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.FETCH_RESERVATION_INVOICE_DETAILS_FAILED,
              reject: actionTypes.FETCH_RESERVATION_INVOICE_DETAILS_REJECT,
            }),
          );
          throw err;
        });
    };
  };
  const loading = () =>
    action(actionTypes.FETCH_RESERVATION_INVOICE_DETAILS_LOADING);
  const success = res =>
    action(actionTypes.FETCH_RESERVATION_INVOICE_DETAILS_SUCCESS, res);

  return request();
};

export const fetchReservationTemporaryPrint = (id , printMode) => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.reservations
        .fetchReservationTemporaryPrint(id, printMode)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.FETCH_RESERVATION_TEMPORARY_PRINT_FAILED,
              reject: actionTypes.FETCH_RESERVATION_TEMPORARY_PRINT_REJECT,
            }),
          );
          throw err;
        });
    };
  };
  const loading = () =>
    action(actionTypes.FETCH_RESERVATION_TEMPORARY_PRINT_LOADING);
  const success = res =>
    action(actionTypes.FETCH_RESERVATION_TEMPORARY_PRINT_SUCCESS, res);

  return request();
};

export const fetchReservationFactorPrint = id => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.reservations
        .fetchReservationFactorPrint(id)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.FETCH_RESERVATION_FACTOR_PRINT_FAILED,
              reject: actionTypes.FETCH_RESERVATION_FACTOR_PRINT_REJECT,
            }),
          );
          throw err;
        });
    };
  };
  const loading = () =>
    action(actionTypes.FETCH_RESERVATION_FACTOR_PRINT_LOADING);
  const success = res =>
    action(actionTypes.FETCH_RESERVATION_FACTOR_PRINT_SUCCESS, res);

  return request();
};

export const fetchReservationTemporaryPrintByPrinterTarget = (
  reserveId,
  printerTarget,
) => {
  const request = () => {
    return dispatch => {
      return API.reservations
        .fetchReservationTemporaryPrintByPrinterTarget(reserveId, printerTarget)
        .then(res => dispatch(success(res)))
        .catch(err => {
          throw err;
        });
    };
  };

  const success = res =>
    action(actionTypes.FETCH_RESERVATION_PRINT_DATA_SUCCESS, res);

  return request();
};

export const fetchAllIncomingReservations = query => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.reservations
        .fetchAllIncomingReservations(query)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.FETCH_INCOMING_RESERVATIONS_FAILED,
              reject: actionTypes.FETCH_INCOMING_RESERVATIONS_REJECT,
            }),
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.FETCH_INCOMING_RESERVATIONS_LOADING);
  const success = res =>
    action(actionTypes.FETCH_INCOMING_RESERVATIONS_SUCCESS, res);

  return request();
};

export const getReservesRequestsList = query => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.reservations
        .fetchAllReservationRequests(query)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.FETCH_RESERVATION_REQUESTS_FAILED,
              reject: actionTypes.FETCH_RESERVATION_REQUESTS_REJECT,
            }),
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.FETCH_RESERVATION_REQUESTS_LOADING);
  const success = res =>
    action(actionTypes.FETCH_RESERVATION_REQUESTS_SUCCESS, res);

  return request();
};

export const fetchAllTableNumbers = () => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.reservations
        .fetchAllTableNumbers()
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.FETCH_TABLE_NUMBERS_FAILED,
              reject: actionTypes.FETCH_TABLE_NUMBERS_REJECT,
            }),
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.FETCH_TABLE_NUMBERS_LOADING);
  const success = res => action(actionTypes.FETCH_TABLE_NUMBERS_SUCCESS, res);

  return request();
};

export const startReservation = id => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.reservations
        .startReservation(id)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.START_RESERVATION_FAILED,
              reject: actionTypes.START_RESERVATION_REJECT,
            }),
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.START_RESERVATION_LOADING);
  const success = res => action(actionTypes.START_RESERVATION_SUCCESS, res);

  return request();
};

export const fetchAllCafeReservations = query => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.reservations
        .fetchAllCafeReservations(query)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.FETCH_ALL_CAFE_RESERVATIONS_FAILED,
              reject: actionTypes.FETCH_ALL_CAFE_RESERVATIONS_REJECT,
            }),
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.FETCH_ALL_CAFE_RESERVATIONS_LOADING);
  const success = res =>
    action(actionTypes.FETCH_ALL_CAFE_RESERVATIONS_SUCCESS, res);

  return request();
};

export const fetchReservationDetails = id => {
  const request = () => {
    return dispatch => {
      dispatch(loading(id));
      return API.reservations
        .fetchReservationDetails(id)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.FETCH_CAFE_RESERVATION_DETAILS_FAILED,
              reject: actionTypes.FETCH_CAFE_RESERVATION_DETAILS_REJECT,
            }),
          );
          throw err;
        });
    };
  };
  const loading = () =>
    action(actionTypes.FETCH_CAFE_RESERVATION_DETAILS_LOADING);
  const success = res =>
    action(actionTypes.FETCH_CAFE_RESERVATION_DETAILS_SUCCESS, res);

  return request();
};

export const editReserveStatus = (params, status) => {
  const request = () => {
    return dispatch => {
      dispatch(loading(params));
      return API.reservations
        .editReserveStatus(params, status)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.EDIT_CAFE_RESERVATION_STATUS_FAILED,
              reject: actionTypes.EDIT_CAFE_RESERVATION_STATUS_REJECT,
            }),
          );
          throw err;
        });
    };
  };
  const loading = () =>
    action(actionTypes.EDIT_CAFE_RESERVATION_STATUS_LOADING);
  const success = res =>
    action(actionTypes.EDIT_CAFE_RESERVATION_STATUS_SUCCESS, res);

  return request();
};

export const clientReason = ({ id, clientReason, otherClientReasons }) => {
  const request = () => {
    return dispatch => {
      dispatch(loading(id));
      return API.reservations
        .clientReason({ id, clientReason, otherClientReasons })
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.EDIT_CAFE_RESERVATION_STATUS_FAILED,
              reject: actionTypes.EDIT_CAFE_RESERVATION_STATUS_REJECT,
            }),
          );
          throw err;
        });
    };
  };
  const loading = () =>
    action(actionTypes.EDIT_CAFE_RESERVATION_STATUS_LOADING);
  const success = res =>
    action(actionTypes.EDIT_CAFE_RESERVATION_STATUS_SUCCESS, res);

  return request();
};

export const fetchAllUserReservations = (userId, query) => {
  const request = () => dispatch => {
    dispatch(loading());

    return API.reservations
      .fetchAllUserReservationsById(userId, query)
      .then(res => dispatch(success(res)))
      .catch(err => {
        dispatch(
          generateErrorAction(err, {
            failure: actionTypes.USER_RESERVATIONS_FAILED,
            reject: actionTypes.USER_RESERVATIONS_REJECT,
          }),
        );

        throw err;
      });
  };
  const loading = () => action(actionTypes.USER_RESERVATIONS_LOADING);
  const success = res => action(actionTypes.USER_RESERVATIONS_SUCCESS, res);

  return request();
};

export const fetchAllCheckedoutOrClientAbsentReserves = query => {
  const request = () => dispatch => {
    dispatch(loading());

    return API.reservations
      .fetchAllCheckedoutOrClientAbsentReserves(query)
      .then(res => dispatch(success(res)))
      .catch(err => {
        dispatch(
          generateErrorAction(err, {
            failure:
              actionTypes.FETCH_ALL_CHECKEDOUT_OR_CLIENT_ABSENT_RESERVES_FAILED,
            reject:
              actionTypes.FETCH_ALL_CHECKEDOUT_OR_CLIENT_ABSENT_RESERVES_REJECT,
          }),
        );

        throw err;
      });
  };
  const loading = () =>
    action(actionTypes.FETCH_ALL_CHECKEDOUT_OR_CLIENT_ABSENT_RESERVES_LOADING);
  const success = res =>
    action(
      actionTypes.FETCH_ALL_CHECKEDOUT_OR_CLIENT_ABSENT_RESERVES_SUCCESS,
      res,
    );

  return request();
};

export const fetchAllClientAbsentOrNotFinishedReserve = query => {
  const request = () => dispatch => {
    dispatch(loading());

    return API.reservations
      .fetchAllClientAbsentOrNotFinishedReserve(query)
      .then(res => dispatch(success(res)))
      .catch(err => {
        dispatch(
          generateErrorAction(err, {
            failure:
              actionTypes.FETCH_ALL_CLIENT_ABSENT_OR_NOT_FINISHED_RESERVES_FAILED,
            reject:
              actionTypes.FETCH_ALL_CLIENT_ABSENT_OR_NOT_FINISHED_RESERVES_REJECT,
          }),
        );

        throw err;
      });
  };
  const loading = () =>
    action(
      actionTypes.FETCH_ALL_CLIENT_ABSENT_OR_NOT_FINISHED_RESERVES_LOADING,
    );
  const success = res =>
    action(
      actionTypes.FETCH_ALL_CLIENT_ABSENT_OR_NOT_FINISHED_RESERVES_SUCCESS,
      res,
    );

  return request();
};

export const checkoutCafeReserves = item => {
  const request = () => dispatch => {
    dispatch(loading());

    return API.reservations
      .checkoutCafeReserves(item)
      .then(res => dispatch(success(res)))
      .catch(err => {
        dispatch(
          generateErrorAction(err, {
            failure: actionTypes.CHECKOUT_CAFE_RESERVES_FAILED,
            reject: actionTypes.CHECKOUT_CAFE_RESERVES_REJECT,
          }),
        );

        throw err;
      });
  };
  const loading = () => action(actionTypes.CHECKOUT_CAFE_RESERVES_LOADING);
  const success = res =>
    action(actionTypes.CHECKOUT_CAFE_RESERVES_SUCCESS, res);

  return request();
};

export const fetchCheckoutReserveDetails = id => {
  const request = () => dispatch => {
    dispatch(loading());

    return API.reservations
      .fetchCheckoutReserveDetails(id)
      .then(res => dispatch(success(res)))
      .catch(err => {
        dispatch(
          generateErrorAction(err, {
            failure: actionTypes.FETCH_CHECKOUT_DETAILS_FAILED,
            reject: actionTypes.FETCH_CHECKOUT_DETAILS_REJECT,
          }),
        );

        throw err;
      });
  };
  const loading = () => action(actionTypes.FETCH_CHECKOUT_DETAILS_LOADING);
  const success = res =>
    action(actionTypes.FETCH_CHECKOUT_DETAILS_SUCCESS, res);

  return request();
};

export const finalCheckoutCafeReserves = item => {
  const request = () => dispatch => {
    dispatch(loading());

    return API.reservations
      .finalCheckoutCafeReserves(item)
      .then(res => dispatch(success(res)))
      .catch(err => {
        dispatch(
          generateErrorAction(err, {
            failure: actionTypes.FINAL_CHECKOUT_CAFE_RESERVES_FAILED,
            reject: actionTypes.FINAL_CHECKOUT_CAFE_RESERVES_REJECT,
          }),
        );

        throw err;
      });
  };
  const loading = () =>
    action(actionTypes.FINAL_CHECKOUT_CAFE_RESERVES_LOADING);
  const success = res =>
    action(actionTypes.FINAL_CHECKOUT_CAFE_RESERVES_SUCCESS, res);

  return request();
};

export const fetchIncominSchematicReservation = item => {
  const request = () => dispatch => {
    dispatch(loading());

    return API.reservations
      .fetchIncominSchematicReservation(item)
      .then(res => dispatch(success(res)))
      .catch(err => {
        dispatch(
          generateErrorAction(err, {
            failure: actionTypes.FETCH_INCOMING_SCHEMATIC_RESERVATION_FAILED,
            reject: actionTypes.FETCH_INCOMING_SCHEMATIC_RESERVATION_REJECT,
          }),
        );

        throw err;
      });
  };
  const loading = () =>
    action(actionTypes.FETCH_INCOMING_SCHEMATIC_RESERVATION_LOADING);
  const success = res =>
    action(actionTypes.FETCH_INCOMING_SCHEMATIC_RESERVATION_SUCCESS, res);

  return request();
};
